module.exports = __webpack_public_path__ + "img/charging-pile2.fd6ddb2e.png";